/*
 * Fraunhofer Institute for Computer Graphics Research (IGD)
 * Competence Center for Information Visualization and Visual Analytics
 *
 * Copyright (c) 2018 Fraunhofer IGD. All rights reserved.
 *
 * This source code is property of the Fraunhofer IGD and underlies
 * copyright restrictions. It may only be used with explicit
 * permission from the respective owner.
 *
 */

import {AnyAction, Reducer} from 'redux';
import {WebsocketActionTypes, WebSocketState} from './types';

// Initial state
const initialState: WebSocketState = {
    sessionId: "",
    prefixRequest : {prefix: "", dateFrom: "", dateTo: ""},
};

// The reducer function
const reducer: Reducer<WebSocketState> = (state = initialState, action: AnyAction) => {
    switch (action.type) {

        case WebsocketActionTypes.SET_SESSION_ID: {
            return Object.assign({}, state, {sessionId: action.payload});
        }
        case WebsocketActionTypes.SET_PREFIX_REQUEST: {
          return Object.assign({}, state, {prefixRequest: {prefix: action.payload.prefix, dateFrom: action.payload.dateFrom, dateTo: action.payload.dateTo}});
        }
      case WebsocketActionTypes.RESET_PREFIX_REQUEST: {
        return Object.assign({}, state, {prefixRequest: initialState.prefixRequest});
      }

        default: {
            return state;
        }
    }
};

export {reducer as websocketReducer};
